module.exports = __webpack_public_path__ + "img/tong.1b49213e.svg";